import "../../../resources/less/Family/ThemePages/ClashOfDimensions.less";
import BaseThematique from "./BaseThematique";

class ClashOfDimensions extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new ClashOfDimensions();
});
